import { DADATA_TOKEN, DADATA_URL, URL, URL_IMPORT } from './constants';
import { getToken, makeRequest } from './utils';

export const getOrdersListRequest = parameters =>
	makeRequest(
		`${URL}/api/orders`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrdersDraftListRequest = parameters =>
	makeRequest(
		`${URL}/api/orders/draft`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrdersImportsListRequest = parameters =>
	makeRequest(
		`${URL_IMPORT}/api/orders/import`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrdersPlanningsListRequest = parameters =>
	makeRequest(
		`${URL}/api/veeroute/plannings`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrdersProcessInfoRequest = (id, parameters) =>
	makeRequest(
		`${URL}/api/veeroute/processes/${id}`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getPlanningsProcessListRequest = (process_id, parameters) =>
	makeRequest(
		`${URL}/api/veeroute/plannings/process/${process_id}`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrdersDetailsRequest = id =>
	makeRequest(`${URL}/api/orders/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteOrderDetailsRequest = id =>
	makeRequest(`${URL}/api/orders/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createOrdersRequest = payload =>
	makeRequest(`${URL}/api/orders`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateOrdersRequest = (id, body) =>
	makeRequest(`${URL}/api/orders/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const getOrdersGroupsListRequest = parameters =>
	makeRequest(
		`${URL}/api/orders_groups`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrdersGroupsWithWaysListRequest = parameters =>
	makeRequest(
		`${URL}/api/orders_groups/withWays`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getWaysListRequest = parameters =>
	makeRequest(
		`${URL}/api/orders_ways`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const groupToGroupRequest = (id, process_id, body) =>
	makeRequest(
		process_id
			? `${URL}/api/orders_groups/process/${process_id}/toGroup`
			: `${URL}/api/orders_groups/${id}/toGroup`,
		{
			method: 'PATCH',
			headers: {
				Accept: 'application/json',
				Authorization: `Bearer ${getToken()}`,
				'Content-Type': 'application/json',
			},
			...(body ? { body: JSON.stringify(body) } : {}),
		},
	);

export const groupToWayRequest = (id, process_id, body) =>
	makeRequest(
		process_id ? `${URL}/api/orders_groups/process/${process_id}/toWay` : `${URL}/api/orders_groups/${id}/toWay`,
		{
			method: 'PATCH',
			headers: {
				Accept: 'application/json',
				Authorization: `Bearer ${getToken()}`,
				'Content-Type': 'application/json',
			},
			...(body ? { body: JSON.stringify(body) } : {}),
		},
	);

export const wayToGroupRequest = (id, body) =>
	makeRequest(`${URL}/api/orders_ways/${id}/toGroup`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const wayToWayRequest = (id, body) =>
	makeRequest(`${URL}/api/orders_ways/${id}/toWay`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderGroupToGroupRequest = body =>
	makeRequest(`${URL}/api/orders/groupToGroup`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderGroupToWayRequest = body =>
	makeRequest(`${URL}/api/orders/groupToWay`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderWayToGroupRequest = body =>
	makeRequest(`${URL}/api/orders/wayToGroup`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderWayToWayRequest = body =>
	makeRequest(`${URL}/api/orders/wayToWay`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderGroupRegroupRequest = (id, body) =>
	makeRequest(`${URL}/api/orders_groups/${id}/regroup`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderGroupResetRequest = (id, process_id, body) =>
	makeRequest(`${URL}/api/orders_groups/process/${process_id}/reset`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const ordersRegroupRequest = body =>
	makeRequest(`${URL}/api/orders/regroup`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const orderCreateReqRequest = body =>
	makeRequest(`${URL}/api/orders/createReq`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const planningRequest = (id, process_id, body) =>
	makeRequest(
		process_id
			? `${URL}/api/orders_groups/process/${process_id}/planning`
			: `${URL}/api/orders_groups/${id}/planning`,
		{
			method: 'PATCH',
			headers: {
				Accept: 'application/json',
				Authorization: `Bearer ${getToken()}`,
				'Content-Type': 'application/json',
			},
			...(body ? { body: JSON.stringify(body) } : {}),
		},
	);

export const selectPlanningRequest = (planning_id, body) =>
	makeRequest(`${URL}/api/veeroute/plannings/${planning_id}/select`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const getGroupCollectionListRequest = (id, process_id = null, parameters) =>
	makeRequest(
		process_id
			? `${URL}/api/orders_groups/process/${process_id}/collections`
			: `${URL}/api/orders_groups/${id}/collections`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCollectionUnplannedListRequest = (id, parameters) =>
	makeRequest(
		`${URL}/api/veeroute/plannings/${id}/collections/unplanned`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getGroupCollectionOrdersListRequest = (id, process_id = null, collection_id, parameters) =>
	makeRequest(
		process_id
			? `${URL}/api/orders_groups/process/${process_id}/collection/${collection_id}`
			: `${URL}/api/orders_groups/${id}/collection/${collection_id}`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getGroupWaysListRequest = (id, planning_id = null, parameters) =>
	makeRequest(
		planning_id ? `${URL}/api/orders_groups/planning/${planning_id}/ways` : `${URL}/api/orders_groups/${id}/ways`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getWayCollectionListRequest = (id, parameters) =>
	makeRequest(
		`${URL}/api/orders_ways/${id}/collections`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getWayCollectionOrdersListRequest = (id, collection_id, parameters) =>
	makeRequest(
		`${URL}/api/orders_ways/${id}/collection/${collection_id}`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getUserInfoRequest = () =>
	makeRequest(`${URL}/api/auth/me`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getUserBadgesRequest = () =>
	makeRequest(`${URL}/api/auth/me/badges`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setUserInfoRequest = body =>
	makeRequest(`${URL}/api/auth/me`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const createUserRequest = payload =>
	makeRequest(`${URL}/api/auth/register`, {
		method: 'POST',
		headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
		body: JSON.stringify({ ...payload }),
	});

export const getCompaniesBySearchRequest = payload =>
	makeRequest(`${DADATA_URL}/suggest/party`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Token ${DADATA_TOKEN}`,
		},
		body: JSON.stringify({ query: payload }),
	});

export const authorizeUserRequest = payload =>
	makeRequest(`${URL}/api/auth/login`, {
		method: 'POST',
		headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
		body: JSON.stringify({ ...payload }),
	});

export const forgotPasswordRequest = payload =>
	makeRequest(`${URL}/api/auth/password/forgot`, {
		method: 'POST',
		headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
		body: JSON.stringify({ ...payload }),
	});

export const resetPasswordRequest = payload =>
	makeRequest(`${URL}/api/auth/password/reset`, {
		method: 'POST',
		headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
		body: JSON.stringify({ ...payload }),
	});

export const getTrailersListRequest = parameters =>
	makeRequest(
		`${URL}/api/trailers`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTrailerInfoRequest = id =>
	makeRequest(`${URL}/api/trailers/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteTrailerRequest = id =>
	makeRequest(`${URL}/api/trailers/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const saveNewTrailerRequest = body =>
	makeRequest(`${URL}/api/trailers`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const updateTrailerRequest = (id, body) =>
	makeRequest(`${URL}/api/trailers/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getDetailsRequest = parameters =>
	makeRequest(
		`${URL}/api/details`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getDetailInfoRequest = id =>
	makeRequest(`${URL}/api/details/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createDetailRequest = payload =>
	makeRequest(`${URL}/api/details`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateDetailDefaultRequest = (id, payload) =>
	makeRequest(`${URL}/api/details/${id}/default`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateDetailRequest = (id, payload) =>
	makeRequest(`${URL}/api/details/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteDetailRequest = id =>
	makeRequest(`${URL}/api/details/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getDetailsBySearchRequest = payload =>
	makeRequest(`${DADATA_URL}/suggest/bank`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Token ${DADATA_TOKEN}`,
		},
		body: JSON.stringify({ query: payload }),
	});

export const getCarsListRequest = parameters =>
	makeRequest(
		`${URL}/api/cars`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getReqsCarsListRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectCar`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getCarInfoRequest = id =>
	makeRequest(`${URL}/api/cars/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteCarRequest = id =>
	makeRequest(`${URL}/api/cars/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createCarRequest = body =>
	makeRequest(`${URL}/api/cars`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const updateCarRequest = (id, body) =>
	makeRequest(`${URL}/api/cars/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getCarEventRequest = id =>
	makeRequest(`${URL}/api/cars/${id}/events`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getPeriodsDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/periods`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getAutoparksRequest = parameters =>
	makeRequest(
		`${URL}/api/autoparks`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getAutoparkCompaniesListRequest = parameters =>
	makeRequest(
		`${URL}/api/autopark_companies`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getAutoparkInfoRequest = id =>
	makeRequest(`${URL}/api/autoparks/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createAutoparkRequest = payload =>
	makeRequest(`${URL}/api/autoparks`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateAutoparkRequest = (id, payload) =>
	makeRequest(`${URL}/api/autoparks/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteAutoparkRequest = id =>
	makeRequest(`${URL}/api/autoparks/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getAutoparksTransportsRequest = (parameters, autoparkId) =>
	makeRequest(
		`${URL}/api/autoparks/${autoparkId}/transports`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getAutoparkTransportInfoRequest = (autoparkId, transportId) =>
	makeRequest(`${URL}/api/autoparks/${autoparkId}/transports/${transportId}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createAutoparkTransportRequest = (autoparkId, payload) =>
	makeRequest(`${URL}/api/autoparks/${autoparkId}/transports`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateAutoparkTransportRequest = (autoparkId, transportId, payload) =>
	makeRequest(`${URL}/api/autoparks/${autoparkId}/transports/${transportId}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteAutoparkTransportRequest = (autoparkId, transportId) =>
	makeRequest(`${URL}/api/autoparks/${autoparkId}/transports/${transportId}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateAutoparkTransportAllowRequest = (payload, autoparkId, transportId) =>
	makeRequest(`${URL}/api/autoparks/${autoparkId}/transports/${transportId}/allow`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getAutoParkTransportTariffTypesRequest = parameters =>
	makeRequest(
		`${URL}/api/autopark_transport_tariff_types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCompaniesTypesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/companies_types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCompaniesAboutInfoRequest = id =>
	makeRequest(`${URL}/api/companies/${id}/about`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getDeliveryStatusesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/delivery_statuses`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getThermoboxesReportsRequest = parameters =>
	makeRequest(
		`${URL}/api/thermoboxes/reports`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const createThermoboxReportRequest = payload =>
	makeRequest(`${URL}/api/thermoboxes/reports`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getThermoboxReportInfoRequest = id =>
	makeRequest(`${URL}/api/thermoboxes/reports/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateThermoboxReportRequest = (id, payload) =>
	makeRequest(`${URL}/api/thermoboxes/reports/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteThermoboxReportRequest = id =>
	makeRequest(`${URL}/api/thermoboxes/reports/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getThermoboxReportDocsRequest = id =>
	makeRequest(`${URL}/api/thermoboxes/reports/${id}/documents`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setThermoboxReportDocsRequest = (id, body) =>
	makeRequest(`${URL}/api/thermoboxes/reports/${id}/setDocuments`, {
		method: 'POST',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		body,
	});

export const getThermoboxReportDocsFormRequest = id =>
	makeRequest(`${URL}/api/thermoboxes/reports/${id}/selectDocuments`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getThermoboxesRequest = parameters =>
	makeRequest(
		`${URL}/api/thermoboxes`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const createThermoboxRequest = payload =>
	makeRequest(`${URL}/api/thermoboxes`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getThermoboxInfoRequest = id =>
	makeRequest(`${URL}/api/thermoboxes/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateThermoboxRequest = (id, payload) =>
	makeRequest(`${URL}/api/thermoboxes/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteThermoboxRequest = id =>
	makeRequest(`${URL}/api/thermoboxes/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getIcepacksRequest = parameters =>
	makeRequest(
		`${URL}/api/icepacks`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const createIcepackRequest = payload =>
	makeRequest(`${URL}/api/icepacks`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getIcepackInfoRequest = id =>
	makeRequest(`${URL}/api/icepacks/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateIcepackRequest = (id, payload) =>
	makeRequest(`${URL}/api/icepacks/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteIcepackRequest = id =>
	makeRequest(`${URL}/api/icepacks/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getIcepacksFillersRequest = parameters =>
	makeRequest(
		`${URL}/api/icepacks_fillers`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getIcepackFillerInfoRequest = id =>
	makeRequest(`${URL}/api/icepacks_fillers/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createIcepackFillerRequest = payload =>
	makeRequest(`${URL}/api/icepacks_fillers`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateIcepackFillerRequest = (id, payload) =>
	makeRequest(`${URL}/api/icepacks_fillers/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteIcepackFillerRequest = id =>
	makeRequest(`${URL}/api/icepacks_fillers/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getIcepacksStatesRequest = parameters =>
	makeRequest(
		`${URL}/api/icepacks_states`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getIcepackStateInfoRequest = id =>
	makeRequest(`${URL}/api/icepacks_states/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createIcepackStateRequest = payload =>
	makeRequest(`${URL}/api/icepacks_states`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateIcepackStateRequest = (id, payload) =>
	makeRequest(`${URL}/api/icepacks_states/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteIcepackStateRequest = id =>
	makeRequest(`${URL}/api/icepacks_states/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getIcepacksFilledRequest = parameters =>
	makeRequest(
		`${URL}/api/icepacks_filled`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getIcepackFilledInfoRequest = id =>
	makeRequest(`${URL}/api/icepacks_filled/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createIcepackFilledRequest = payload =>
	makeRequest(`${URL}/api/icepacks_filled`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateIcepackFilledRequest = (id, payload) =>
	makeRequest(`${URL}/api/icepacks_filled/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteIcepackFilledRequest = id =>
	makeRequest(`${URL}/api/icepacks_filled/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getTypesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrderGroupsTypesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/orders_groups_types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getVeerouteConfigsRequest = parameters =>
	makeRequest(
		`${URL}/api/veeroute/configs`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getVeerouteTransportTypesRequest = parameters =>
	makeRequest(
		`${URL}/api/veeroute/transport/types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getFeaturesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/features`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTenderTypesRequest = parameters =>
	makeRequest(
		`${URL}/api/tender_types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTenderCompaniesRequest = parameters =>
	makeRequest(
		`${URL}/api/tender_companies`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getSeatTypesRequest = params =>
	makeRequest(
		`${URL}/api/types_seats`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		params,
	);

export const getModesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/modes`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getRatesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/rates`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTonnagesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/tonnages`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOwnershipsDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/ownerships`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTimezonesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/timezones`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getLegalsDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/legals`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCarTypesRequest = parameters =>
	makeRequest(
		`${URL}/api/cars_types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getStatusesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/statuses`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCompaniesDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/companies`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCompanyRequest = id =>
	makeRequest(`${URL}/api/companies/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getCompanySettingsRequest = id =>
	makeRequest(`${URL}/api/companies/${id}/settings`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateCompanySettingsRequest = (id, body) =>
	makeRequest(`${URL}/api/companies/${id}/settings`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getCompanyAdminSettingsRequest = id =>
	makeRequest(`${URL}/api/companies/${id}/modules`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateCompanyAdminSettingsRequest = (id, body) =>
	makeRequest(`${URL}/api/companies/${id}/modules`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const updateCompanyRequest = (id, body) =>
	makeRequest(`${URL}/api/companies/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getAddressesRequest = parameters =>
	makeRequest(
		`${URL}/api/addresses`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getAddressInfoRequest = id =>
	makeRequest(`${URL}/api/addresses/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createAddressRequest = payload =>
	makeRequest(`${URL}/api/addresses`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateAddressRequest = (id, payload) =>
	makeRequest(`${URL}/api/addresses/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const createCompanyDescriptionRequest = (id, payload) =>
	makeRequest(`${URL}/api/companies/${id}/about`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getDeliveryMethodsRequest = parameters =>
	makeRequest(
		`${URL}/api/delivery_methods`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const deleteAddressRequest = id =>
	makeRequest(`${URL}/api/addresses/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getAddressesBySearchRequest = payload =>
	makeRequest(`${DADATA_URL}/suggest/address`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Token ${DADATA_TOKEN}`,
		},
		body: JSON.stringify({ query: payload }),
	});

export const getContactsRequest = (parameters, addressId) =>
	makeRequest(
		`${URL}/api/addresses/${addressId}/contacts`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getContactInfoRequest = (addressId, contactId) =>
	makeRequest(`${URL}/api/addresses/${addressId}/contacts/${contactId}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createContactRequest = (payload, addressId) =>
	makeRequest(`${URL}/api/addresses/${addressId}/contacts`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateContactRequest = (payload, addressId, contactId) =>
	makeRequest(`${URL}/api/addresses/${addressId}/contacts/${contactId}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteContactRequest = (addressId, contactId) =>
	makeRequest(`${URL}/api/addresses/${addressId}/contacts/${contactId}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateContactDefaultRequest = (payload, addressId, contactId) =>
	makeRequest(`${URL}/api/addresses/${addressId}/contacts/${contactId}/default`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getUsersListRequest = parameters =>
	makeRequest(
		`${URL}/api/users`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getRelationshipListRequest = parameters =>
	makeRequest(
		`${URL}/api/company_relationship`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getUserRequest = id =>
	makeRequest(`${URL}/api/users/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteUserRequest = id =>
	makeRequest(`${URL}/api/users/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createUserItemRequest = body =>
	makeRequest(`${URL}/api/users`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const updateUserRequest = (id, body) =>
	makeRequest(`${URL}/api/users/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getRelationshipRequest = id =>
	makeRequest(`${URL}/api/company_relationship/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getOrdersWaysRequest = id =>
	makeRequest(`${URL}/api/orders_ways/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteRelationshipRequest = id =>
	makeRequest(`${URL}/api/company_relationship/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteOrdersWaysRequest = id =>
	makeRequest(`${URL}/api/orders_ways/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getShippersDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/companies/shippers`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getCarriersDictionaryRequest = parameters =>
	makeRequest(
		`${URL}/api/companies/cargo`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const createRelationshipItemRequest = body =>
	makeRequest(`${URL}/api/company_relationship`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const createOrdersWaysItemRequest = body =>
	makeRequest(`${URL}/api/orders_ways`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const updateRelationshipRequest = (id, body) =>
	makeRequest(`${URL}/api/company_relationship/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});
export const updateOrdersWaysRequest = (id, body) =>
	makeRequest(`${URL}/api/orders_ways/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getUsersRolesListRequest = parameters =>
	makeRequest(
		`${URL}/api/users_roles`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getUserRoleRequest = id =>
	makeRequest(`${URL}/api/users_roles/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteUserRoleRequest = id =>
	makeRequest(`${URL}/api/users_roles/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createUserRoleRequest = body =>
	makeRequest(`${URL}/api/users_roles`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const updateUserRoleRequest = (id, body) =>
	makeRequest(`${URL}/api/users_roles/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getRoutesRequest = () =>
	makeRequest(`${URL}/api/routes`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getReqsRequest = (id, parameters) =>
	makeRequest(
		`${URL}/api${id}`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getReqsFilterRequest = (id, parameters) =>
	makeRequest(
		`${URL}/api${id}/filter`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const deleteReqRequest = (id, pathname) =>
	makeRequest(`${URL}/api${pathname}/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createMyReqRequest = (body, pathname) =>
	makeRequest(`${URL}/api${pathname}`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const recreateReqRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/recreate`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
	});

export const updateMyReqWithPayloadRequest = (id, field, body) =>
	makeRequest(`${URL}/api/reqs/${id}${field}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getBlobForReqListRequest = query =>
	makeRequest(`${URL}${query}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
	});

export const updateMyReqRequest = (id, field, body, pathname) =>
	makeRequest(`${URL}/api${pathname}/${id}/${field}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	});

export const getReqDetailsRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const takeReqRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/take`, {
		method: 'PATCH',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getRequestSelectionRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectCompany`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getRequestsCountRequest = () =>
	makeRequest(`${URL}/api/reqs/count`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getNotificationsListRequest = () =>
	makeRequest(`${URL}/api/notifications`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const markNotificationRequest = id =>
	makeRequest(`${URL}/api/notifications/${id}/mark`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getRequestDriversRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectDriver`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getEmailVerifyInfoRequest = () =>
	makeRequest(`${URL}/api/auth/email/verify`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const emailResendRequest = () =>
	makeRequest(`${URL}/api/auth/email/resend`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
	});

export const emailVerifyRequest = (id, hash) =>
	makeRequest(`${URL}/api/auth/email/verify/${id}/${hash}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getAuditDataRequest = (entity, id) =>
	makeRequest(`${URL}/api/${entity}${id ? `/${id}` : ''}/audit`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getReqDocsRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/documents/group`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getReqEventRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/event`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getSelectFetchRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectFetch`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getSelectDoneRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectDone`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getSelectDoneExpressRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectDoneExpress`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateSelectDoneRequest = (idSelectDone, idSelectPoint, payload) =>
	makeRequest(`${URL}/api/reqs/${idSelectDone}/points/${idSelectPoint}/setDone`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateSelectDoneExpressRequest = (idSelectDone, payload) =>
	makeRequest(`${URL}/api/reqs/${idSelectDone}/setDoneExpress`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getSelectFlightRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectFlight`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const specifyFlightRequest = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setFlight`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const setFetchRequest = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setFetch`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getSelectProductInvoiceRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectProductInvoice`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setProductInvoiceRequest = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setProductInvoice`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getSelectChosenCompanyRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectChosenCompany`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setChosenCompanyRequest = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setChosenCompany`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getInformationRequest = parameters =>
	makeRequest(
		`${URL}/api/home`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getPointDocumentsRequest = (reqId, pointId, parameters) =>
	makeRequest(
		`${URL}/api/reqs/${reqId}/points/${pointId}/selectDocuments`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const setPointDocumentsRequest = (reqId, pointId, body) =>
	makeRequest(`${URL}/api/reqs/${reqId}/points/${pointId}/setDocuments`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		...(body ? { body } : {}),
	});

export const getDocumentsRequest = (reqId, parameters) =>
	makeRequest(
		`${URL}/api/reqs/${reqId}/selectDocuments`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getDocumentsExpressRequest = (reqId, parameters) =>
	makeRequest(
		`${URL}/api/reqs/${reqId}/selectDocumentsExpress`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const setDocumentsRequest = (reqId, body) =>
	makeRequest(`${URL}/api/reqs/${reqId}/setDocuments`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		...(body ? { body } : {}),
	});

export const setDocumentsExpressRequest = (reqId, body) =>
	makeRequest(`${URL}/api/reqs/${reqId}/setDocumentsExpress`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		...(body ? { body } : {}),
	});

export const getChatsListRequest = () =>
	makeRequest(`${URL}/api/chats`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getSelectCompanyNoteRequest = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectCompanyNote`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setCompanyNoteRequest = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setCompanyNote`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getTrailerTypesRequest = () =>
	makeRequest(`${URL}/api/trailers_types?receive=all`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
	});

export const getTrailerEventRequest = id =>
	makeRequest(`${URL}/api/trailers/${id}/events`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const acceptTermsRequest = payload =>
	makeRequest(`${URL}/api/auth/accept`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const logoutRequest = () =>
	makeRequest(`${URL}/api/auth/logout`, {
		method: 'POST',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getSelectCustomUid = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectCustomUid`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setSelectCustomUidRequest = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setCustomUid`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getSelectCost = id =>
	makeRequest(`${URL}/api/reqs/${id}/selectCost`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const setSelectCost = (id, payload) =>
	makeRequest(`${URL}/api/reqs/${id}/setCost`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getRelationshipSettingsListRequest = parameters =>
	makeRequest(
		`${URL}/api/relationship_settings`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getStagesRequest = () =>
	makeRequest(`${URL}/api/stages?receive=all`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getStagesMyTransportsRequest = () =>
	makeRequest(`${URL}/api/stages/my_transports?receive=all`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getDocumentTypesRequest = group =>
	makeRequest(`${URL}/api/document_types/${group}?receive=all`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createRelationshipSettingsRequest = payload =>
	makeRequest(`${URL}/api/relationship_settings`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const getRelationshipSettings = id =>
	makeRequest(`${URL}/api/relationship_settings/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteRelationshipSettingsRequest = id =>
	makeRequest(`${URL}/api/relationship_settings/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const updateRelationshipSettingsRequest = (id, body) =>
	makeRequest(`${URL}/api/relationship_settings/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

export const getCategoriesRequest = parameters =>
	makeRequest(
		`${URL}/api/categories`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getOrgTypesRequest = parameters =>
	makeRequest(
		`${URL}/api/org_types`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTaxSystemRequest = parameters =>
	makeRequest(
		`${URL}/api/tax_systems`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getTaxRatesRequest = ({ taxSystemId }, parameters) =>
	makeRequest(
		`${URL}/api/tax_rates/${taxSystemId}`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const setCompanyAccreditationRequest = (id, payload) =>
	makeRequest(`${URL}/api/companies/${id}/setAccreditation`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify(payload),
	});

export const getOrderGroupInfoRequest = id =>
	makeRequest(`${URL}/api/orders_groups/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const deleteOrderGroupRequest = id =>
	makeRequest(`${URL}/api/orders_groups/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createOrderGroupRequest = data =>
	makeRequest(`${URL}/api/orders_groups`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify(data),
	});

export const updateOrderGroupRequest = (id, data) =>
	makeRequest(`${URL}/api/orders_groups/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify(data),
	});

export const createImportedOrdersGroupRequest = file => {
	const formData = new FormData();
	formData.append('file', file);

	return makeRequest(`${URL_IMPORT}/api/orders/import`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: formData,
	});
};
